import { ReactNode } from 'react';
import { AlertTriangle } from 'lucide-react';

import { Button } from '@/components/ui/button';

export interface ErrorStateAction {
  label: string;
  onClick: () => void;
  variant?: 'default' | 'outline' | 'ghost' | 'secondary';
}

interface ErrorStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  actions?: ErrorStateAction[];
}

export function ErrorState({ icon, title, description, actions }: ErrorStateProps) {
  return (
    <div
      className="flex flex-col items-center justify-center px-4 py-8 sm:px-6 sm:py-12 text-center"
      role="alert"
    >
      <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-xl bg-destructive/10 text-destructive [&_svg]:h-7 [&_svg]:w-7">
        {icon ?? <AlertTriangle />}
      </div>
      <h6 className="text-lg font-semibold mb-2">
        {title}
      </h6>
      {description && (
        <p className={`text-sm text-muted-foreground max-w-[400px] ${actions?.length ? 'mb-6' : ''}`}>
          {description}
        </p>
      )}
      {actions && actions.length > 0 && (
        <div className="flex gap-3">
          {actions.map((action) => (
            <Button
              key={action.label}
              variant={action.variant ?? 'default'}
              onClick={action.onClick}
            >
              {action.label}
            </Button>
          ))}
        </div>
      )}
    </div>
  );
}

export default ErrorState;
